export default class CampaignInjector {
  constructor(inject, validate) {
    this.inject = inject
    this.validate = validate
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/campaigns/CampaignInjector.js